import { Modal } from 'antd';

function error(text: string) {
  Modal.error({
    title: 'Алдаа',
    content: text,
  });
}

function success(text: string) {
  Modal.success({
    title: 'Амжилттай',
    content: text,
  });
}

export const dialog = {
  success,
  error,
};
